var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((4),function(index){return _c('div',{key:index,staticClass:"navigation-link-column col-lg-3 col-sm-6 col-xs-12"},[_c('InfraActionLinkPlaceholder')],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }